import { getFragment } from '../graphql';
import {
    type PriorAuthorizationInfoFragment,
    PriorAuthorizationStatus,
} from '../graphql/generated/graphql';
import type { BasicPrescriberOrderFragment } from '../util/cabinet/prescriber-orders';

import { useFlags } from './use-flags';

export const usePriorAuthorizationDetails = (
    order?: BasicPrescriberOrderFragment | PriorAuthorizationInfoFragment
) => {
    const { nonDrxPriorAuthorizationEnabled } = useFlags();

    const isNonDrxPriorAuthorization =
        order?.__typename === 'PriorAuthorization' &&
        nonDrxPriorAuthorizationEnabled;

    const isDrxPriorAuthorization =
        order?.__typename === 'DigitallyReceivedPrescriberOrder';

    let priorAuthorizationDetails;
    if (isNonDrxPriorAuthorization) {
        priorAuthorizationDetails = order;
    } else if (isDrxPriorAuthorization) {
        priorAuthorizationDetails = getFragment(
            order.applicablePriorAuthorization
        );
    }

    const isApprovedPriorAuthorization =
        priorAuthorizationDetails?.status ===
            PriorAuthorizationStatus.Approved ||
        priorAuthorizationDetails?.status ===
            PriorAuthorizationStatus.AppealApproved;

    return {
        isApprovedPriorAuthorization,
        isNonDrxPriorAuthorization,
        priorAuthorizationDetails,
    };
};
